<template>
    <div id="app">
        <PatientNotes :Mode="'Add'" :Type="AppServiceID"/>
    </div>
</template>

<script>
import Vue from 'vue';
import PatientNotes from '@/components/DPEBB/Administrator/PatientNotes.vue'; 
import LayoutDefault from '@/Common/Default/DefaultLayout.vue'; 
export default {

  data: function (){
        return {
        AppServiceID :6,
        }
    },
    components: {
  
        PatientNotes
    },
created: function() { 
    this.$emit('update:layout', LayoutDefault);
    this.AppServiceID = this.$store.getters.GetDentalID;
},    
beforeCreate: function() {
    this.$store.dispatch('AddServiceID',this.$store.getters.GetDentalID);
    this.$store.dispatch('GetMenuItems',this.$store.getters.GetDentalID);
},

}
</script>

<style>

</style>
